import { useQuery } from '@tanstack/react-query';
import { useAxiosCmsInstance } from '@gov-nx/api';
import { useAppLanguageSelector } from '@gov-nx/core/hooks';
import { useConfiguration } from '@gov-nx/core/service';
import { useCmsUrlPath } from '@gov-nx/store';
import type { CmsLandingPageResponse } from './types';

export const useCmsLandingPageQuery = () => {
	const { cmsKeyCache } = useConfiguration();
	const { language } = useAppLanguageSelector();
	const { baseCmsUrlPath } = useCmsUrlPath();
	const { axiosCmsInstance } = useAxiosCmsInstance();

	const query = useQuery({
		queryFn: async () => {
			const response = await axiosCmsInstance.get<CmsLandingPageResponse>(
				`/landing-page/${language}.json?v=${cmsKeyCache}`
			);
			return response.data.data.data;
		},
		refetchOnWindowFocus: false,
		queryKey: ['cms-landing-page', language],
	});

	return {
		query,
		baseCmsUrlPath,
	};
};
